module.exports = __webpack_public_path__ + "img/video-help.f84766a2.gif";